<div class="dc-menu-button-container">
	<button
		(click)="onMenuButtonClick($event, menu)"
		[disabled]="actions()?.length === 0"
		[matTooltipDisabled]="actions().length === 0"
		[matTooltipPosition]="tooltipPosition$()"
		[matTooltip]="tooltip() | translate"
		[ngClass]="[sizeClass()]"
		class="dc-menu-button"
		type="button"
	>
		<span
			[ngClass]="[buttonConfig()?.iconClass ? buttonConfig()?.iconClass : '']"
			class="dc-menu-button-icon"
		>
			@if (buttonConfig()?.icon !== 'TEMPLATE') {
				<i
					class="fad"
					[class]="buttonConfig()?.icon"
				></i>
			} @else {
				<ng-container *ngTemplateOutlet="buttonConfig()?.template"></ng-container>
			}
		</span>
	</button>
</div>
<p-menu
	#menu
	[model]="items$()"
	[popup]="true"
	appendTo="body"
>
	<ng-template
		let-item
		pTemplate="item"
	>
		<a
			class="flex items-center justify-between p-menuitem-link"
			pRipple
		>
			<span>{{ item.label | translate }}</span>
			@if (item.badge) {
				<p-badge [value]="item.badge" />
			}
			@if (item.icon) {
				<span [class]="item.icon"></span>
			}
			@if (item.shortcut) {
				<span class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">
					{{ item.shortcut }}
				</span>
			}
		</a>
	</ng-template>
</p-menu>
